module.exports = __webpack_public_path__ + "img/standbild.5910012f.png";